import * as React from "react";
import {
  styledContainer,
  styledModal,
  note,
  logo,
} from "./OfferSearchModal.module.scss";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";

export const StyledModal: React.FC<{
  children: React.ReactNode;
  onShow?(): void;
  onHide?(): void;
}> = (props) => {
  return (
    <Modal {...props} className={styledModal}>
      {props.children}
    </Modal>
  );
};

export const StyledContainer: React.FC<{ children: JSX.Element }> = (props) => {
  return <Container className={styledContainer}>{props.children}</Container>;
};

export const Note: React.FC<{ children: React.ReactNode }> = (props) => {
  return <div className={note}>{props.children}</div>;
};
export const Logo: React.FC = () => {
  return (
    <svg className={logo}>
      <use xlinkHref="/svg/sonesta-gray-offer-modal.svg#SonestaLogo"> </use>
    </svg>
  );
};
